export default __webpack_public_path__ + "static/media/image.007db766.svg";